import bsf from "../../assets/bsf.jpg"
import cortica from "../../assets/cortica.jpg"

const Portfolio_data = [
  {
    id: 1,
    category: "Brainstorm Force",
    totalLike: "750",
    title: "Ultimate Addons For Elementor and Ultimate Addons For Beaver Builder Plugin Development",
    image: ('%s', bsf),
    desc: "Build quality products and tools that are simple to use, affordable, and reliable to help entrepreneurs, professionals, and bloggers grow online.",
    desc2: "Brainstorm Force are the makers of popular WordPress products like the Astra theme, UAE, UABB, page builder addons, Schema Pro and a lot more. Innovative tools and solutions empower people to achieve the freedom to get their business online and drive it forward.",
    link: "https://brainstormforce.com/products/"
  },
  {
    id: 2,
    category: "Cortica Web Solutions",
    totalLike: "200",
    title: "Web Design | ",
    image: ('%s', cortica),
    desc: "Build quality websites, connect with customer and need to create the website according to customers need and after that maintain that website.",
    desc2: "There are two kinds of site Static and Dynamic site. Site improvement implies making 24*7 web-based sales reps for your business.",
    link: "https://corticawebsolutions.com/",
  },
]
export default Portfolio_data
